"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = void 0;
var tslib_1 = require("tslib");
var map = function (tag) { return ((0, tslib_1.__assign)({ _id: tag.id, label: tag.label, postCount: tag.publicationCount }, (tag.url && { tagPageUrl: tag.url.path }))); };
exports.map = map;
//# sourceMappingURL=platformized-mapper.js.map